<form [formGroup]="form">
  <div
    class="header h-[55px] flex justify-start items-center pl-[50px] mb-[35px] bg-[#DEE2E6]"
  >
    <p class="!m-0">Request for Quotation (RFQ)</p>
    <p
      class="text-[#] !mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] px-[13px] !h-[24px] flex items-center justify-center"
    >
      Construction Work
    </p>
  </div>

  <div class="!px-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2">
    <span class="label"> Site Preparation</span>
    <app-rich-textEditor
      (contentChange)="setSitePreparation($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('site_preparation_control')?.value"
      [placeHolder]="'Site Preparation'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('site_preparation_control')?.touched &&
        form.get('site_preparation_control')?.invalid
      "
      class="error"
    >
      Site preparation is required
    </div>

    <div class="">
      <button
        type="button"
        class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
        (click)="site_preparation_file.click()"
      >
        <span class="text-[0.7rem]"> Attach Document </span>
        <img
          class="rounded-full ml-[4px]"
          src="assets/icons/document.svg"
          alt="document icon"
        />
      </button>
      <input
        type="file"
        #site_preparation_file
        (change)="onFileUpload($event, 'site_preparation_file_control')"
        multiple
        hidden
      />
    </div>

    <div
      *ngIf="
        form.get('site_preparation_file_control')?.touched &&
        form.get('site_preparation_file_control')?.invalid
      "
      class="error"
    >
      At least one attachment is required.
    </div>

    <!-- Old attachments -->

    <div
      class="flex flex-col"
      *ngFor="
        let oldSitePreparationFile of oldSitePreparationFiles;
        let i = index
      "
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <img
              [src]="getFileIcon(oldSitePreparationFile)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ oldSitePreparationFile?.title }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="
            removeOldFile(
              i,
              oldSitePreparationFile?.id,
              'site_preparation_file_control'
            )
          "
        />
      </div>
    </div>

    <!-- New attachments -->
    <div
      class="flex flex-col"
      *ngFor="
        let fileControl of site_preparation_file_control.controls;
        let i = index
      "
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Check if the uploaded file is an image -->
            <img
              [src]="getFileIcon(fileControl?.value)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ fileControl.value.name }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="removeFile(i, 'site_preparation_file_control')"
        />
      </div>
    </div>

    <span class="label mt-[14px]"> Structural and Civil Works</span>
    <app-rich-textEditor
      (contentChange)="setStructuralCivilWorks($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('civil_works_control')?.value"
      [placeHolder]="'Structural and Civil Works'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('civil_works_control')?.touched &&
        form.get('civil_works_control')?.invalid
      "
      class="error"
    >
      Structural and civil works is required
    </div>

    <div class="">
      <button
        type="button"
        class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
        (click)="structure_civil.click()"
      >
        <span class="text-[0.7rem]"> Attach Document </span>
        <img
          class="rounded-full ml-[4px]"
          src="assets/icons/document.svg"
          alt="document icon"
        />
      </button>
      <input
        type="file"
        #structure_civil
        (change)="onFileUpload($event, 'structure_civil_file_control')"
        multiple
        hidden
      />
    </div>

    <div
      *ngIf="
        form.get('structure_civil_file_control')?.touched &&
        form.get('structure_civil_file_control')?.invalid
      "
      class="error"
    >
      At least one attachment is required.
    </div>

    <div
      class="flex flex-col"
      *ngFor="
        let oldStructureCivilFile of oldStructureCivilFiles;
        let i = index
      "
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Check if the uploaded file is an image -->
            <img
              [src]="getFileIcon(oldStructureCivilFile)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ oldStructureCivilFile?.title }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="
            removeOldFile(
              i,
              oldStructureCivilFile?.id,
              'structure_civil_file_control'
            )
          "
        />
      </div>
    </div>

    <div
      class="flex flex-col"
      *ngFor="
        let fileControl of structure_civil_file_control.controls;
        let i = index
      "
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Check if the uploaded file is an image -->
            <img
              [src]="getFileIcon(fileControl.value)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ fileControl.value.name }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="removeFile(i, 'structure_civil_file_control')"
        />
      </div>
    </div>

    <span class="label mt-[14px]"> MEP Works </span>
    <app-rich-textEditor
      (contentChange)="setMEPWorks($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('mep_works_control')?.value"
      [placeHolder]="'MEP Works'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('mep_works_control')?.touched &&
        form.get('mep_works_control')?.invalid
      "
      class="error"
    >
      MEP works is required
    </div>

    <span class="label"> Finishing and Fit-Out</span>
    <app-rich-textEditor
      (contentChange)="setFitOut($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('fit_out_control')?.value"
      [placeHolder]="'Finishing and Fit-Out'"
    ></app-rich-textEditor>

    <div
      *ngIf="
        form.get('fit_out_control')?.touched &&
        form.get('fit_out_control')?.invalid
      "
      class="error"
    >
      Finishing and fit-out is required
    </div>

    <span class="label"> Health & Safety Compliance</span>
    <app-rich-textEditor
      (contentChange)="setHealthSafetyCompliance($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('health_safety_control')?.value"
      [placeHolder]="'Health & Safety Compliance'"
    ></app-rich-textEditor>

    <div
      *ngIf="
        form.get('health_safety_control')?.touched &&
        form.get('health_safety_control')?.invalid
      "
      class="error"
    >
      Health & safety compliance is required
    </div>

    <div class="">
      <button
        type="button"
        class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
        (click)="health_safety.click()"
      >
        <span class="text-[0.7rem]"> Attach Document </span>
        <img
          class="rounded-full ml-[4px]"
          src="assets/icons/document.svg"
          alt="document icon"
        />
      </button>
      <input
        type="file"
        #health_safety
        (change)="onFileUpload($event, 'health_safety_file_control')"
        multiple
        hidden
      />
    </div>

    <div
      *ngIf="
        form.get('health_safety_file_control')?.touched &&
        form.get('health_safety_file_control')?.invalid
      "
      class="error"
    >
      At least one attachment is required.
    </div>

    <div
      class="flex flex-col"
      *ngFor="let oldHealthSafetyFile of oldHealthSafetyFiles; let i = index"
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Check if the uploaded file is an image -->
            <img
              [src]="getFileIcon(oldHealthSafetyFile)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ oldHealthSafetyFile?.title }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="
            removeOldFile(
              i,
              oldHealthSafetyFile?.id,
              'health_safety_file_control'
            )
          "
        />
      </div>
    </div>

    <div
      class="flex flex-col"
      *ngFor="
        let fileControl of health_safety_file_control.controls;
        let i = index
      "
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Check if the uploaded file is an image -->
            <img
              [src]="getFileIcon(fileControl.value)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ fileControl.value.name }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="removeFile(i, 'health_safety_file_control')"
        />
      </div>
    </div>

    <span class="label mt-[14px]"> Post-Construction Activities</span>
    <app-rich-textEditor
      (contentChange)="setPostConstruction($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('post_construction_control')?.value"
      [placeHolder]="'Post-Construction Activities'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('post_construction_control')?.touched &&
        form.get('post_construction_control')?.invalid
      "
      class="error"
    >
      Post-construction activities is required
    </div>
  </div>

  <div
    class="!pr-[32px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="handleBack()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="moveToNextStep()"
      >
        Next
      </button>
    </div>
  </div>
</form>
